import { isLocaleValid } from './index';

/**
 * Разбор `{-$locale}` при сопоставлении адреса: не язык - этот вариант маршрута пропускается.
 *
 * Без этого роутер на несуществующем адресе (`/dashboard/nope`) подбирал ближайший маршрут, считая
 * первое слово языком: `locale: "dashboard"`. Экран "не найдено" рисовался с этим параметром, и все
 * ссылки меню, которые берут параметры текущего адреса, вели на `/dashboard/dashboard/...` - снова
 * "не найдено". Снаружи это выглядело как нижнее меню, которое не реагирует на нажатия
 * (телефон 17.09.2026). `false` роутер понимает как "этот вариант не подходит, ищи дальше".
 *
 * Стоит на двух маршрутах: `/{-$locale}` и его безпутевом `_layout`. Безпутевой маршрут без своего
 * разбора делит с родителем узел в дереве сопоставления и затирает родительский разбор пустым
 * (@tanstack/router-core 1.171, `parseSegments`), а со своим разбором получает отдельный узел.
 * Убрать один из двух - и ошибка вернётся; тест `localeParam.test.ts` это ловит.
 */
export const parseLocaleParam = (params: { locale?: string }): { locale?: string } | false =>
  params.locale === undefined || isLocaleValid(params.locale) ? { locale: params.locale } : false;
